'use client';

import { useEffect, useState } from 'react';

/**
 * Returns true when viewport width >= minWidth.
 * Evaluates on mount and updates on resize.
 */
export default function useIsLarge(minWidth = 500) {
  const [isLarge, setIsLarge] = useState(false);

  useEffect(() => {
    const mql =
      typeof window !== 'undefined'
        ? window.matchMedia(`(min-width: ${minWidth}px)`)
        : null;

    const apply = () => setIsLarge(!!mql?.matches);
    apply();

    mql?.addEventListener('change', apply);
    return () => mql?.removeEventListener('change', apply);
  }, [minWidth]);

  return isLarge;
}
